/* eslint-disable camelcase */
import React from 'react'
import TableRow from './TableRow'
import { TableContainer, Main } from './TableStyled'
import { TableProps } from './interfaces'
export default function Table({
  array,
  user_id,
  // toFix,
  handleAbove,
  handleNotification,
  strokeColor,
  requestBetReply,
  setRoundId,
  audio,
  betAmount,
  multiplier,
  payout,
  grid,
}: TableProps) {
  return (
    <Main>
      <TableContainer multiplier={multiplier} grid={grid}>
        <thead>
          <tr>
            <th className='thUser'>USER</th>
            {betAmount && <th className='thPayout'>BET</th>}
            {payout && <th className='thPayout'>PAYOUT</th>}
            {multiplier && <th className='thMP'>MP</th>}
            <th className='thProfit'>WIN AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {array.map((t, id) => (
            <TableRow
              user_id={user_id}
              t={t}
              // toFix={toFix}
              handleAbove={handleAbove}
              handleNotification={handleNotification}
              key={id} // bad practice, need unique key
              strokeColor={strokeColor}
              requestBetReply={requestBetReply}
              setRoundId={setRoundId}
              audio={audio}
              betAmount={betAmount}
              multiplier={multiplier}
            />
          ))}
        </tbody>
      </TableContainer>
    </Main>
  )
}
